import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Background from "./components/Background";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ContactModal from "./components/ContactModal";
import { ContactModalProvider } from "./context/ContactModalContext";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import WhyUsPage from "./pages/WhyUsPage";
import GlobalPage from "./pages/GlobalPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <ContactModalProvider>
        <ScrollToTop />
        <div className="relative min-h-screen text-white overflow-x-hidden">
          <Background />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:category" element={<ProductsPage />} />
              <Route path="/products/:category/:slug" element={<ProductDetailPage />} />
              <Route path="/why-us" element={<WhyUsPage />} />
              <Route path="/global-reach" element={<GlobalPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <ContactModal />
        </div>
      </ContactModalProvider>
    </BrowserRouter>
  );
}

export default App;
